module.exports = __webpack_public_path__ + "static/media/shopify-multi-currency.e3a125d9.png";